import profile1 from '../../assets/Images/Choosecard/profile1.webp'
import profile2 from '../../assets/Images/Choosecard/profile2.webp'
import profile3 from '../../assets/Images/Choosecard/profile3.webp'
import profile4 from '../../assets/Images/Choosecard/profile4.webp'
import profile5 from '../../assets/Images/Choosecard/profile5.jpeg'
import profile6 from '../../assets/Images/Choosecard/profile6.webp'
import profile7 from '../../assets/Images/Choosecard/profile7.jpeg'
import profile8 from '../../assets/Images/Choosecard/profile8.jpeg'
import profile9 from '../../assets/Images/Choosecard/profile9.webp'
import profile10 from '../../assets/Images/Choosecard/profile10.jpeg'

export const review = [
    {
        img:profile1,
        name:"James Haller.",
        date:"Jun 21,2019",
        para:"Linked Bricks understands my investment needs. With small entry points, high liquidity, and a transparent process, instills confidence in every investment decision. Highly recommended!",
    },
    {
        img: profile2,
        name:"Brad Anthony",
        date:"March 21,2021",
        shortpara:"Investing in property in London through Linked Bricks was a decision that changed the game for ",
        para:"Investing in property in London through Linked Bricks was a decision that changed the game for me. What began as a venture into a new market turned into a success story. The returns exceeded expectations, making every step with Linked Bricks a chapter in my financial success narrative.",
    },
    {
        img:"Avatar2.png",
        name:"Emma Davies",
        date:"April 2,2022",
        shortpara:"I took a leap of faith with Linked Bricks in the bustling real estate scene of Dubai. Today,",
        para:"I took a leap of faith with Linked Bricks in the bustling real estate scene of Dubai. Today, I proudly share my success story – a tale of strategic investment, impressive returns, and a partnership with Linked Bricks that has rewritten my financial narrative",
    },
    {
        img:"Avatar3.png",
        name:"Daniel Wilson",
        date:"Feb 10,2020",
        shortpara:"Investing in property, especially in Dubai, was a dream. Linked Bricks not only made it a ",
        para:"Investing in property, especially in Dubai, was a dream. Linked Bricks not only made it a reality but turned it into a story of remarkable returns and financial triumph.",
    },
    {
        img:"Avatar.png",
        name:"Olivia Hall",
        date:"Dec 1,2021",
        shortpara:"Linked Bricks made my investment journey in LA a captivating story. From the initial step into ",
        para:"Linked Bricks made my investment journey in LA a captivating story. From the initial step into the market to the remarkable returns, every page turned with Linked Bricks felt like a strategic move towards financial success.",
    },
    {
        img:profile3,
        name:"Liam Green",
        date:"Nov 10,2022",
        shortpara:"The high returns transformed my simple investment into a thrilling story of financial growth.",
        para:"The high returns transformed my simple investment into a thrilling story of financial growth.",
    },
    {
        img:profile4,
        name:"Isabella Smith",
        date:"May 21,2023",
        shortpara:"The decision to invest in Dubai through this platform added a layer of excitement and substantial ",
        para:"The decision to invest in Dubai through this platform added a layer of excitement and substantial returns that transformed my narrative",
    },
    {
        img:profile5,
        name:"Emmanuel Henry",
        date:"May 18,2022",
        shortpara:"Linked Bricks empowered me to sell my home directly, avoiding heavy commissions. The transparent ",
        para:"Linked Bricks empowered me to sell my home directly, avoiding heavy commissions. The transparent process and control over the sale were game-changers. Selling a home has never been this easy!",
    },
    {
        img:profile6,
        name:"Zayn Ansari",
        date:"July 08,2023",
        shortpara:"Navigating the platform, I found a property in the exact neighborhood I'd been longing for. ",
        para:"Navigating the platform, I found a property in the exact neighborhood I'd been longing for. Linked Bricks didn't just help me buy a house; it made me a part of a community I now proudly call home.",
    },
    {
        img:profile7,
        name:"Ryan Evans",
        date:"Dec 21,2021",
        shortpara:"The platform revealed an amazing property in Oxfordshire that I now proudly own. Linked Bricks  ",
        para:"The platform revealed an amazing property in Oxfordshire that I now proudly own. Linked Bricks turned a mere search into a tangible moment of finding a place that truly feels like home.",
    },
    {
        img:profile8,
        name:"Rebecca Brown",
        date:"May 21,2020",
        shortpara:"Looking back, I recall the excitement of finding my ideal property in London with Linked Bricks. The platform ",
        para:"Looking back, I recall the excitement of finding my ideal property in London with Linked Bricks. The platform showcased a range of homes, and I eventually sealed the deal on a house that perfectly matched my vision. Linked Bricks made my London property dreams a reality.",
    },
    {
        img:profile9,
        name:"Liam Wright",
        date:"Aug 05,2021",
        shortpara:"My move to a new city was met with unexpected ease, thanks to Linked Bricks. I found the perfect ",
        para:"My move to a new city was met with unexpected ease, thanks to Linked Bricks. I found the perfect rental property on the same day I started my search. The platform's efficiency turned what could have been a stressful move into a seamless transition. ",
    },
    {
        img:profile10,
        name:"Ruchi Patel",
        date:"Jun 21,2021",
        shortpara:"Linked Bricks played a crucial role in my last-minute move. In a single day, I discovered and  ",
        para:"Linked Bricks played a crucial role in my last-minute move. In a single day, I discovered and secured a fantastic rental property through the platform. It was a real-life incident that showcased the speed and convenience Linked Bricks brings to the tenant experience",
    },




]